import { Datetime } from 'vue-datetime';
import { VueGoodTable } from 'vue-good-table';
import ApplicationResponseService from '../../../services/ApplicationResponses.js';
import StatusService from '../../../services/Status.js';
import moment from 'moment';
import Paginate from 'vuejs-paginate';

if($('#network-applications').length){
    var app = new Vue({
        el: '#network-applications',
        data: {
            networkId: networkId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            showScoring: showScoring == 1 ? false : true,
            hideNDA: hideNDA,
            selfApproval: selfApproval == 1 ? false : true,
            applicationType: applicationType,
            display:'list',
            endDate: '',
            startDate: '',
            data:{},
            isLoading: true,
            applicationResponses: [],
            categories: [],
            statuses: [],
            tags: [],
            statusId: 1,
            counts:{
                approved:0,
                disapproved:0,
                pending:0
            },
            columns: [
                {
                    label: 'Application Date',
                    field: 'applicationDate',
                },
                {
                    label: 'Innovation',
                    field: 'innovation',
                    hidden: applicationType == 'expert' ? true : false,
                },
                {
                    label: 'Applicant',
                    field: 'applicant'
                },
                {
                    label: 'NDA',
                    field: 'nda',
                    hidden: hideNDA,
                },
                {
                    label: 'Score',
                    field: 'score',
                    hidden: showScoring == 1 ? false : true,
                },
                {
                    label: 'Pipeline Stage',
                    field: 'pipelineStage',
                    hidden: pipelineStages ? false : true,
                },
                {
                    label: 'Tags',
                    field: 'tags',
                    sortable: false,
                    hidden: hasTags > 0 ? false : true,
                    tdClass: 'tags-class',
                },
                {
                    label: 'Likes / Dislikes',
                    field: 'likes',
                },
                {
                    label: 'Response',
                    field: 'response',
                },
                {
                    label: 'View',
                    field: 'view',
                    sortable: false
                },
                {
                    label: 'Actions',
                    field: 'actions',
                    sortable: false,
                    hidden: selfApproval == 1 ? false : true
                },
                {
                    label: 'id',
                    field: 'id',
                    hidden: true,
                },
                {
                    label: 'status',
                    field: 'status',
                    hidden: true,
                }
            ],
            rows: [],
            totalRecords: 0,
            lastPage: 0,
            serverParams: {
                sort: {
                    field: '', 
                    type: '',
                },
                statusFilter:  1,
                tagFilter: '',
                categoryFilter:  '',
                searchFilter: null,
                page: 1, 
                total: 0
            },
            networkTypeId: networkTypeId
        },
        methods: {
            setUpArrow(vote) {
                if (vote && vote == 'yes') {
                    return '/images/upvote.png';
                }
                return '/images/upvote-empty.png';
            },
            setDownArrow(vote) {
                if (vote && vote != 'yes') {
                    return '/images/downvote.png';
                }
                return '/images/downvote-empty.png';
            },
            get(){
                this.isLoading = true;
                axios.get('/api/v1/network/'+this.networkId+'/'+this.applicationType+'/applications', { 
                    params:{
                        startDate:this.startDate,
                        endDate:this.endDate,
                        statusId:this.serverParams.statusFilter,
                        tagId:this.serverParams.tagFilter,
                        categoryId:this.serverParams.categoryFilter,
                        search:this.serverParams.searchFilter,
                        sortField:this.serverParams.sort.field,
                        sortType:this.serverParams.sort.type,
                        page:this.serverParams.page
                    }
                }).then((response) =>  {
                    this.data = response.data.applications;
                    this.categories = response.data.categories;
                    this.counts = response.data.counts;
                    var rows = [];
                    this.serverParams.perPage = this.data.per_page;
                    this.serverParams.page = this.data.current_page;
                    this.totalRecords = this.data.total;
                    this.lastPage = this.data.last_page;
                    this.data.data.forEach(function(object, index){
                        var row = {
                            applicationDate:moment(object.created_at).format('LL'),
                            innovation:object.innovation ? object.innovation.title : null,
                            applicant:object.user.private ? object.user.organisation : object.user.first_name + ' ' + object.user.last_name,
                            nda:object.nda,
                            score:object.score_percentage ? object.score_percentage +'%' : 'N/A',
                            pipelineStage:object.pipeline_stage ? object.pipeline_stage.name : 'None',
                            response:object.application_response,
                            id:object.id,
                            status:object.status_id,
                            video_url:object.video_url,
                            tags:object.tags,
                            likes: object.likes,
                            dislikes: object.dislikes,
                            vote: object.vote
                        }

                        rows.push(row);
                    });

                    this.rows = rows;
                    this.setStorage();
                    this.isLoading = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            setStorage() {
                sessionStorage.setItem("page", this.serverParams.page);
                sessionStorage.setItem("startDate", this.startDate);
                sessionStorage.setItem("endDate", this.endDate);
                sessionStorage.setItem("statusId", this.serverParams.statusFilter);
                sessionStorage.setItem("search", this.serverParams.searchFilter);
                sessionStorage.setItem("sortField", this.serverParams.sort.field);
                sessionStorage.setItem("sortType", this.serverParams.sort.type);
            },
            changeDate(){
                if(!this.isLoading){
                    this.serverParams.page = 1; 
                    this.get();
                }
            },
            getTags(){
                axios.get('/api/v1/network/'+this.networkSlug+'/tags').then((response) =>  {
                    this.tags = response.data;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            paginate(object){
                this.get();
            },
            switchView(view){
                this.display = view; 
            },
            changeStatus(id, status){
                axios.get('/api/v1/network/'+this.networkId+'/'+this.applicationType+'/update-status/'+id+'/'+status).then(() =>  {
                    this.get();
                    this.$toasted.success('Application Status Updated');
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            updateParams(newProps) {
                if (this.serverParams.tagFilter) {
                    sessionStorage.setItem("tag", this.serverParams.tagFilter);
                }
                if (this.serverParams.categoryFilter) {
                    sessionStorage.setItem("category", this.serverParams.categoryFilter);
                }
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.get();
            },
            onSortChange(params) {
                this.updateParams({page: 1});
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
              this.get();
            },
            onFilterChange() {
                this.updateParams({page: 1});
                this.get();
            },
            onSearchChange: _.debounce(function () {
                this.updateParams({page: 1});
                this.get();
            }, 1000),
            resetDate: function(dateValue) {
                if(dateValue == 'start'){
                    this.startDate = '';
                }else{
                    this.endDate = '';
                }
                this.get();
            },
            getExportUrl(){
                var data = {
                    startDate:this.startDate,
                    endDate:this.endDate,
                    statusId:this.serverParams.statusFilter,
                    categoryId:this.serverParams.categoryFilter,
                    tagId:this.serverParams.tagFilter,
                    search:this.serverParams.searchFilter,
                    sortField:this.serverParams.sort.field,
                    sortType:this.serverParams.sort.type
                }

                var querystring = this.encodeQueryData(data);

                return '/organisation/'+this.networkGroupSlug+'/'+this.networkSlug+'/export/'+this.applicationType+'-applications?'+querystring;
            },
            resetFilters(){
                sessionStorage.removeItem("tag");
                sessionStorage.removeItem("category");
                this.serverParams = {
                    sort: {
                        field: '', 
                        type: '',
                    },
                    statusFilter:  1,
                    categoryFilter:  '',
                    tagFilter:  '',
                    searchFilter: null,
                    page: 1, 
                    total: this.totalRecords
                }
                this.endDate = '',
                this.startDate = '',
                this.get();
            },
            getTime(date){
                return moment(date).format('LL');
            },
            truncate(str, n, useWordBoundary){
                if (str.length <= n) { return str; }
                const subString = str.substr(0, n-1); // the original check
                return (useWordBoundary 
                  ? subString.substr(0, subString.lastIndexOf(" ")) 
                  : subString) + "...";
            },
            encodeQueryData(data) {
                const ret = [];
                for (let d in data)
                  ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
                return ret.join('&');
            },
            errorHandler(error){
                if(typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
                this.isLoading = false;
            },
        },
        components: {
            'Datetime': Datetime,
            'paginate': Paginate,
            'vue-good-table':VueGoodTable
        },
        mounted () {
            if (sessionStorage.getItem("tag")) {
                this.serverParams.tagFilter = sessionStorage.getItem("tag");
            }
            if (sessionStorage.getItem("category")) {
                this.serverParams.categoryFilter = sessionStorage.getItem("category");
            }
            if (sessionStorage.getItem("page")) {
                this.serverParams.page = sessionStorage.getItem("page");
            }
            if (sessionStorage.getItem("startDate")) {
                this.startDate = sessionStorage.getItem("startDate");
            }
            if (sessionStorage.getItem("endDate")) {
                this.endDate = sessionStorage.getItem("endDate");
            }
            if (sessionStorage.getItem("statusId")) {
                this.serverParams.statusFilter = sessionStorage.getItem("statusId");
            }
            if (sessionStorage.getItem("search") && sessionStorage.getItem("search") !== 'null') {
                this.serverParams.searchFilter = sessionStorage.getItem("search");
            }
            if (sessionStorage.getItem("sortField")) {
                this.serverParams.sort.field = sessionStorage.getItem("sortField");
            }
            if (sessionStorage.getItem("sortType")) {
                this.serverParams.sort.type = sessionStorage.getItem("sortType");
            }

            this.get();
            this.getTags();

            if (this.networkTypeId === 5) {
                this.columns.splice(7, 1);
            }

            ApplicationResponseService.getApplicationResponses().then(data => {
                this.applicationResponses = data;
            });

            StatusService.getStatuses().then(data => {
                this.statuses = data;
            });
        }
    });
}